























































import Vue, { PropType } from "vue";
import { A as VcA } from "@/components";
import { Data, Method, Props } from "./PlanOptionDetailOnetimePurchasePro";
import LocalePrice from "@/lib/localePrice";
import Locale from "@/lib/locale";
import SalePriceGuide from "./SalePriceGuide.vue";
import ForeignSalePriceGuide from "@/components/PlanOptionDetail/ForeignSalePriceGuide.vue";

export default Vue.extend<Data, Method, {}, Props>({
  name: "vc-plan-option-detail-onetime-purchase-pro",
  components: {
    VcA,
    "vc-sale-price-guide": SalePriceGuide,
    "vc-foreign-sale-price-guide": ForeignSalePriceGuide
  },
  props: {
    lang: {
      type: Object as PropType<Props["lang"]>,
      default: () => ({})
    },
    link: {
      type: String as PropType<Props["link"]>,
      default: ""
    },
    target: {
      type: String as PropType<Props["target"]>,
      default: ""
    },
    price: {
      type: String as PropType<Props["price"]>,
      default: ""
    },
    beforePrice: {
      type: String as PropType<Props["beforePrice"]>,
      default: ""
    },
    isJapanSaleTarget: {
      type: Boolean as PropType<Props["isJapanSaleTarget"]>,
      default: false
    },
    isOverseasSaleTarget: {
      type: Boolean as PropType<Props["isOverseasSaleTarget"]>,
      default: false
    },
    discountRate: {
      type: Object as PropType<Props["discountRate"]>,
      default: () => ({})
    }
  },
  computed: {
    priceText() {
      return this.lang.note_just_price.replace(
        ":price",
        LocalePrice.getPrice(Locale.getLocale(), Number(this.price))
      );
    },
    beforePriceText() {
      return LocalePrice.getPrice(Locale.getLocale(), Number(this.beforePrice));
    },
    discountRateText(): string {
      return this.lang.sale.discount.replace(
        ":discount",
        this.discountRate["normal"][Locale.getLocale()]
      );
    }
  }
});
